import { render, staticRenderFns } from "./ProspectingForm.vue?vue&type=template&id=c0b2ed72&scoped=true&"
import script from "./ProspectingForm.vue?vue&type=script&lang=js&"
export * from "./ProspectingForm.vue?vue&type=script&lang=js&"
import style0 from "./ProspectingForm.vue?vue&type=style&index=0&id=c0b2ed72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b2ed72",
  null
  
)

export default component.exports